export function selectCustomFieldOptions<Option extends { value: string }>(value: unknown, options?: Option[]) {
  const selected: readonly unknown[] = typeof value === "string" ? [value] : Array.isArray(value) ? value : [];
  return options?.filter((option) => selected.includes(option.value));
}
